function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-s3-1{fill:url(#linear-gradient);}.cls-s3-2{fill:url(#linear-gradient-2);}.cls-s3-3{fill:url(#linear-gradient-3);}.cls-s3-4{fill:url(#linear-gradient-4);}.cls-s3-5{fill:url(#linear-gradient-5);}.cls-s3-6{fill:url(#linear-gradient-6);}.cls-s3-7{fill:url(#linear-gradient-7);}.cls-s3-8{fill:url(#linear-gradient-8);}.cls-s3-9{fill:url(#linear-gradient-9);}.cls-s3-10{fill:url(#linear-gradient-10);}.cls-s3-11{fill:url(#linear-gradient-11);}.cls-s3-12{fill:url(#linear-gradient-12);}.cls-s3-13{fill:url(#linear-gradient-13);}.cls-s3-14{fill:url(#linear-gradient-14);}.cls-s3-15{fill:url(#linear-gradient-15);}.cls-s3-16{fill:#f4c156;}.cls-s3-17{fill:#c09233;}.cls-s3-18{fill:#eb3825;}.cls-s3-19{fill:#cb2b27;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 38.38,
  y1: 409.63,
  x2: 329.26,
  y2: 409.63,
  gradientTransform: "translate(38.45 139.75) rotate(-15.76)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3f280f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 6.98,
  y1: -52.53,
  x2: 34.43,
  y2: -52.53,
  gradientTransform: "translate(38.45 139.75) rotate(-15.76)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6a6a6e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6a6a6e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 88.56,
  y1: -52.53,
  x2: 116,
  y2: -52.53,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: -32.28,
  y1: -3.18,
  x2: 155.26,
  y2: -3.18,
  gradientTransform: "translate(35.27 123.17)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: -18.55,
  y1: 99.74,
  x2: 141.54,
  y2: 99.74,
  gradientTransform: "translate(38.45 139.75) rotate(-15.76)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3f280f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 31.38,
  y1: 99.74,
  x2: 91.61,
  y2: 99.74,
  xlinkHref: "#linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 23.47,
  y1: 252.59,
  x2: 99.52,
  y2: 252.59,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 36.34,
  y1: 207.38,
  x2: 86.94,
  y2: 207.38,
  gradientTransform: "translate(92.44 115.22)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5b8222"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#51771d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#375911"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#112d00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0a2800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 36.34,
  y1: 222.81,
  x2: 86.94,
  y2: 222.81,
  gradientTransform: "translate(96.64 114.64)",
  xlinkHref: "#linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 36.34,
  y1: 238.25,
  x2: 86.94,
  y2: 238.25,
  gradientTransform: "translate(100.83 114.06)",
  xlinkHref: "#linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 36.34,
  y1: 253.69,
  x2: 86.94,
  y2: 253.69,
  gradientTransform: "translate(105.02 113.48)",
  xlinkHref: "#linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 36.34,
  y1: 269.13,
  x2: 86.94,
  y2: 269.13,
  gradientTransform: "translate(109.21 112.9)",
  xlinkHref: "#linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 36.34,
  y1: 284.56,
  x2: 86.94,
  y2: 284.56,
  gradientTransform: "translate(113.41 112.32)",
  xlinkHref: "#linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 36.34,
  y1: 300,
  x2: 86.94,
  y2: 300,
  gradientTransform: "translate(117.6 111.74)",
  xlinkHref: "#linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 36.34,
  y1: 315.44,
  x2: 86.94,
  y2: 315.44,
  gradientTransform: "translate(121.79 111.16)",
  xlinkHref: "#linear-gradient-8"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "s3",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "s3-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-1",
  d: "M352.16,587.44c-36.48,10.29-69.68,7.74-99-7.67-69.21-36.36-87.51-131.52-88.26-135.55l45.55-8.41L187.66,440l22.76-4.25c.14.77,15.12,77.32,64.4,103.08,23.6,12.34,52.87,11,87-4.07,4.95-3,38.09-24,48.86-63,8.47-30.63,1.46-65.72-20.83-104.3l40.09-23.18c28.92,50,37.39,97.34,25.16,140.59-17.19,60.8-69.54,89.69-71.77,90.89l-.76.42-.79.35A217,217,0,0,1,352.16,587.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-2",
  d: "M70.77,127.53a13.72,13.72,0,0,1-9.47,16.94h0A13.74,13.74,0,0,1,44.36,135L17.45,39.61a13.73,13.73,0,0,1,9.48-16.94h0a13.72,13.72,0,0,1,16.93,9.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-3",
  d: "M149.28,105.38a13.72,13.72,0,0,1-9.48,16.94h0a13.73,13.73,0,0,1-16.93-9.48L96,17.45A13.72,13.72,0,0,1,105.44.52h0A13.72,13.72,0,0,1,122.37,10Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-s3-4",
  x: 3,
  y: 95.98,
  width: 187.54,
  height: 48.03,
  transform: "translate(-28.95 30.79) rotate(-15.76)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-5",
  d: "M25.94,163.74l26.69,94.59A61.8,61.8,0,0,0,128.9,301l35.1-9.9a61.82,61.82,0,0,0,42.71-76.28L180,120.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-6",
  d: "M153.7,210.86a30.12,30.12,0,1,1-37.16-20.8A30.13,30.13,0,0,1,153.7,210.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-7",
  d: "M181.29,279.52,108.1,300.17s15.63,4.79,22.8,24.45l-.15.05,35,124L210.5,436,174.37,308l-.07-.08C173.75,300.31,174.11,289.46,181.29,279.52Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-s3-8",
  x: 128.78,
  y: 316.16,
  width: 50.6,
  height: 12.86,
  transform: "translate(-81.81 53.96) rotate(-15.76)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-s3-9",
  x: 132.97,
  y: 331.02,
  width: 50.6,
  height: 12.86,
  transform: "translate(-85.69 55.66) rotate(-15.76)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-s3-10",
  x: 137.16,
  y: 345.88,
  width: 50.6,
  height: 12.87,
  transform: "translate(-89.57 57.36) rotate(-15.76)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-s3-11",
  x: 141.36,
  y: 360.74,
  width: 50.6,
  height: 12.87,
  transform: "translate(-93.44 59.05) rotate(-15.76)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-s3-12",
  x: 145.55,
  y: 375.59,
  width: 50.6,
  height: 12.87,
  transform: "translate(-97.32 60.75) rotate(-15.76)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-s3-13",
  x: 149.74,
  y: 390.45,
  width: 50.6,
  height: 12.87,
  transform: "translate(-101.2 62.45) rotate(-15.76)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-s3-14",
  x: 153.93,
  y: 405.31,
  width: 50.6,
  height: 12.86,
  transform: "translate(-105.07 64.14) rotate(-15.76)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-s3-15",
  x: 158.13,
  y: 420.17,
  width: 50.6,
  height: 12.87,
  transform: "matrix(0.96, -0.27, 0.27, 0.96, -108.95, 65.84)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-16",
  d: "M486.68,685.07c.4,0,.79,0,1.18,0a18.57,18.57,0,0,0,18.66-17.39,94.22,94.22,0,0,1,3.08-19.6,79.76,79.76,0,0,1,13.32-27.35c8.65-11.53,20.74-21.34,36.35-29.59a18.21,18.21,0,0,0,7.56-25,19.1,19.1,0,0,0-25.56-7.51c-29.76,15.72-50.47,36.56-61.95,62.25a119.61,119.61,0,0,0-8.41,27.33,139.82,139.82,0,0,0-2,17.34A18.71,18.71,0,0,0,486.68,685.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-16",
  d: "M851.35,590.17c15.74,8.14,28,17.87,36.81,29.34a80.36,80.36,0,0,1,13.75,27.25,96,96,0,0,1,3.39,19.58,18.76,18.76,0,0,0,18.92,17.26c.4,0,.79,0,1.18,0A18.5,18.5,0,0,0,942.91,664a137.38,137.38,0,0,0-2.31-17.32,120.88,120.88,0,0,0-8.83-27.27c-11.88-25.61-32.92-46.31-62.92-61.82a19,19,0,0,0-25.45,7.68A18.34,18.34,0,0,0,851.35,590.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-17",
  d: "M843.4,565.22a18.34,18.34,0,0,0,8,24.95c15.74,8.14,28,17.87,36.81,29.34l43.61-.15c-11.88-25.61-32.92-46.31-62.92-61.82A19,19,0,0,0,843.4,565.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-17",
  d: "M479.32,620.91l43.6-.15c8.65-11.53,20.74-21.34,36.35-29.59a18.21,18.21,0,0,0,7.56-25,19.1,19.1,0,0,0-25.56-7.51C511.51,574.38,490.8,595.22,479.32,620.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-18",
  d: "M276.1,234.84l51.07,169.92L370,547.19c8.77,29.16,36.18,49.18,67.18,49.08l503.57-1.73c31-.11,58.09-20.32,66.4-49.53l11.56-40.66,50.08-176.08-61.88.22c-38.19.13-71.68,24.76-82.41,60.6-29.15,71.91-281.53,89-348.15,1.2,0,0,85.2-100.21-36.41-143.16S276.1,234.84,276.1,234.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-19",
  d: "M327.17,404.76,370,547.19c8.77,29.16,36.18,49.18,67.18,49.08l503.57-1.73c31-.11,58.09-20.32,66.4-49.53l11.56-40.66c-17.36,26.42-50.66,62-113.48,65.18C747.27,577.58,414.33,564.79,327.17,404.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-16",
  d: "M267.06,247.85h0a10.77,10.77,0,0,0,12.35,7.38c28.37-5.41,78.83-12.23,109.19-12.33,54.72-.19,103.48,7.14,144.93,21.78,28.92,10.21,46.12,24.36,51.13,42,7.68,27.2-14,60.94-23,71.61h0a18.34,18.34,0,0,0-.6,23.05h0c32.09,42.28,103.92,67.33,192.16,67h0c79.55-.28,168.83-22.76,188.93-72.37l.33-.8.24-.82a65.34,65.34,0,0,1,24.12-34.1A67.75,67.75,0,0,1,1007,347.14l61.75-.21a9.47,9.47,0,0,0,9.11-6.79h0a9.41,9.41,0,0,0-9.25-11.86l-61.75.21c-38.19.13-71.68,24.75-82.42,60.61C895.35,461,643,478.05,576.34,390.29c0,0,85.67-101.51-36.42-143.15-108.56-37-227.81-19.44-264.65-12.51A10.43,10.43,0,0,0,267.06,247.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s3-16",
  d: "M1067.44,701.37l-792.53,5.7a16.19,16.19,0,0,1-16.39-15.87,16,16,0,0,1,16.14-16l792.53-5.71c14.4,0,25.92-3.9,33.32-11.13a32,32,0,0,0,9.37-23.49c-.15-19.53-15.06-39.26-43.26-39.16a16.18,16.18,0,0,1-16.39-15.87,16,16,0,0,1,16.14-16c49-.17,75.77,36.4,76,70.9a63.2,63.2,0,0,1-18.88,46.2C1114.07,690.22,1096.65,701.27,1067.44,701.37Z"
})));

var SvgS3 = function SvgS3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1142.41 707.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgS3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/s3.b6516ce8.svg";
export { ForwardRef as ReactComponent };